import { TFunction } from 'next-i18next'
import { BigSale } from 'src/core/models'
import { getFormatedPrice } from 'src/core/helpers'

export interface SaleSupplierInvoiceDetailsLabels {
  label: string,
  strongLabel: string | number,
  secondLabel?: string,
}

export const saleSupplierInvoiceDetailsLabels = (t: TFunction, sale: BigSale): SaleSupplierInvoiceDetailsLabels[] => [
  {
    label: t('Transactions.Amount'),
    strongLabel: getFormatedPrice(sale.supplierInvoiceProjectPrice, sale.projectCurrencyCode),
  },
  {
    label: t('Transactions.CTFees'),
    strongLabel: getFormatedPrice(-sale.supplierInvoiceClimatetradeFee, sale.projectCurrencyCode),
  },
  {
    label: t('Transactions.VAT'),
    strongLabel: getFormatedPrice(sale.supplierInvoiceVat, sale.projectCurrencyCode),
  },
  {
    label: t('Deposits.Total'),
    strongLabel: getFormatedPrice(sale.supplierInvoiceTotalAmount, sale.projectCurrencyCode),
  }
]

